import LegalPage from "@/components/LegalPage";

const sections = [
  {
    heading: "Introduction",
    body: "KSDevArc respects your privacy and is committed to protecting your personal data in accordance with Singapore's Personal Data Protection Act (PDPA). This Privacy Policy explains how we collect, use, disclose, and protect information obtained through our website and services.",
  },
  {
    heading: "Information We Collect",
    body: "We may collect your name, email address, phone number, company details, project information, and any information you voluntarily submit through contact forms, emails, or enquiries. We may also collect technical information such as IP addresses, browser types, device information, and website usage data.",
  },
  {
    heading: "How We Use Your Information",
    body: "We use your information to respond to enquiries, prepare quotations, provide website development, lightweight SaaS, AI and AI Technology and consultancy services, improve our website, maintain security, comply with legal obligations, and communicate with you regarding requested services.",
  },
  {
    heading: "Cookies",
    body: "Our website may use essential and analytics cookies to improve functionality and understand website performance. You may manage cookies through your browser settings.",
  },
  {
    heading: "Sharing of Information",
    body: "We do not sell personal information. Information may be shared with trusted service providers, hosting providers, professional advisers, or authorities where required by law.",
  },
  {
    heading: "Data Security and Retention",
    body: "We implement reasonable technical and organizational safeguards to protect personal information. Data is retained only as long as necessary for business, legal, or regulatory purposes.",
  },
  {
    heading: "Your Rights",
    body: "Subject to applicable law, you may request access to, correction of, or withdrawal of consent relating to your personal information by contacting us.",
  },
  {
    heading: "Intellectual Property and Submitted Materials",
    body: "Any drawings, specifications, images, reference materials, or project information submitted to KSDevArc remain the property of their respective owners. Submitted materials will only be used for evaluating, quoting, and delivering requested services.",
  },
  {
    heading: "Portfolio and Website Content",
    body: "Architectural concepts, renderings, visualizations, drawings, images, logos, and website content are protected by intellectual property laws and may not be reproduced without permission. Conceptual renderings may differ from final constructed works.",
  },
  {
    heading: "Third-Party Links",
    body: "Our website may contain links to external websites. We are not responsible for the content, security, or privacy practices of third-party websites.",
  },
  {
    heading: "Changes to this Policy",
    body: "We may update this Privacy Policy from time to time. Updates will be published on this website with a revised effective date.",
  },
  {
    heading: "Contact Us",
    body: "KSDevArc\nUEN: 53526011C\nEmail: admin@ksdevarc.com\nWebsite: www.ksdevarc.com",
  },
];

export default function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      lastUpdated="18 June 2026"
      sections={sections}
      seoDescription="How KSDevArc collects, uses and protects your personal data under Singapore's PDPA."
    />
  );
}
